import { render, staticRenderFns } from "./AddRecruitmentDriveTest.vue?vue&type=template&id=77cc498b&scoped=true"
import script from "./AddRecruitmentDriveTest.vue?vue&type=script&lang=js"
export * from "./AddRecruitmentDriveTest.vue?vue&type=script&lang=js"
import style0 from "./AddRecruitmentDriveTest.vue?vue&type=style&index=0&id=77cc498b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77cc498b",
  null
  
)

export default component.exports